export function truncateText(string, count) {
  if (typeof string !== "string" || typeof count !== "number") return ""
  return string.length <= count ? string : string.slice(0, count) + "..."
}
